import React from "react";
import { LinkButton } from "../../../../../core/atoms";
import { CallToActionBlock } from "../../../../components/ctaBlock/ctaBlock";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import "./aboutEnquire.scss";

export const AboutEnquireCta = () => {
    const backgroundImage: ISrcSet = {
        default: "https://resources.travellocal.com/about-us/about-us-enquire_large.jpg",
        srcs: [
            {
                src: "https://resources.travellocal.com/about-us/about-us-enquire_small.jpg",
                width: 512,
            },
            {
                src: "https://resources.travellocal.com/about-us/about-us-enquire_large.jpg",
                width: 1920,
            },
        ],
    };
    return (
        <div className="about-enquire-cta">
            <CallToActionBlock
                bodyTitle="Find your perfect destination and start planning your trip"
                boxAlignX="left"
                boxAlignY="top"
                backgroundImage={backgroundImage}
                alt="A group of people celebrating Holi, a popular ancient Hindu festival"
            >
                <LinkButton
                    className="primary-button heading--4 text--light"
                    to={WebRoutes.enquiryForm({ campaign: "about-enquire-cta" })}
                >
                    Find your destination
                </LinkButton>
            </CallToActionBlock>
        </div>
    );
};
